import { IconCart } from '@/entities/catalog-inside-page/PriceItem/IconCart'
import { useAddProductToCartMutation } from '@/shared/api-rtk/api-list/cartApi'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser'
import { changeCountItems } from '@/shared/store/slice/cartSlice'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { useGetCartItemsQuery } from '@/shared/api-rtk/index.js'
import { excludeArticleDiscount } from '../../../../shared/constants/discount'
import { redirect } from 'next/navigation'

export const PriceItem = ({
    productPrice,
    productId,
    quantity,
    sampler,
    isSertifikat,
    sertificatValue,
    sampler_id,
    specials = false,
    sku,
    name
}) => {
    //Поиск товара в корзине
    const { data: productsInCart } = useGetCartItemsQuery()
    const itemInCart =
        productsInCart && productsInCart.data?.includes(productId)
    const [buttonCart, setButtonCart] = React.useState(itemInCart || false)

    useEffect(() => {
        setButtonCart(itemInCart || false)
    }, [productId])

    const navigate = (path) => redirect(path)

    const [addProductToCart] = useAddProductToCartMutation()

    const { userAuth, userInfo } = useGetIsAuthUser()

    const userGroup = userAuth ? Number(userInfo.customerGroupId) : 0

    let special = null

    for (let index = 0; index < specials.length; index++) {
        const element = specials[index]
        const groupId = Number(element.customer_group_id)
        if (
            (groupId === 1 && userGroup !== 2) ||
            (groupId === 2 && userGroup === 2)
        ) {
            special = element
        }
    }

    const dispatch = useDispatch()

    const addItemCart = async (cert = false) => {
        if (buttonCart) {
            navigate('/cart')
        } else if (
            (productsInCart?.data.length > 0 && cert) ||
            (productsInCart.data?.includes('187') && !cert)
        ) {
            toast.warn(
                'Вы можете одновременно заказать либо один Сертификат либо продукцию на нашем сайте.'
            )
        } else {
            try {
                const body = { product_id: productId, quantity: 1 }
                if (sampler) {
                    body['option'] = { [sampler_id]: sampler }
                }
                if (isSertifikat) {
                    body.option = { cert: sertificatValue }
                }

                const result = await addProductToCart(body)
                const data = result.data

                const total = parseInt(data.total.split(' ')[1])
                dispatch(changeCountItems(total))
                toast.success(data.total)
                setButtonCart(!buttonCart)
            } catch (error) {
                console.log(error)
            }
        }
    }

    //price
    const currentPrice = Number(productPrice).toLocaleString()

    return (
        <div className={'PriceItem'}>
            <div>
                {!excludeArticleDiscount.find((el) => el === sku) && sku[0] !== 'W' && name !== 'Подарочный сертификат' && (
                <div style={{fontSize: "17px"}}>
                    <span style={{ backgroundColor: '#f23288', color: 'white', padding: '2px 3px', marginRight: '5px' }}>
                        15%
                    </span> 
                    <u onClick={() => navigate('/login')} style={{ marginRight: '5px', cursor: 'pointer' }}>авторизуйся</u> 
                    как косметолог и получи скидку
                </div>)}
                <div className={'price'}>
                    {(productPrice > 0 || Number(quantity) > 0) && (
                        <>
                            <h3 className={'price-current'}>
                                {special
                                    ? Number(special.price).toLocaleString()
                                    : currentPrice}{' '}
                                ₽
                            </h3>
                            {special && (
                                <h3 className={'price-sale'}>{currentPrice} ₽</h3>
                            )}
                        </>
                    )}
                </div>
            </div>
            {
                Number(quantity) > 0 ? (
                    !isSertifikat ? 
                        <button
                            className={buttonCart ? 'adding-cart' : null}
                            onClick={() => {
                                addItemCart()
                            }}
                            disabled={productPrice <= 0 || Number(quantity) <= 0}
                        >
                            {buttonCart ? '' : <IconCart />}
                            {buttonCart ? 'Добавлено в корзину' : 'В корзину'}
                        </button>
                    :
                        <button
                            className={buttonCart ? 'adding-cart' : null}
                            onClick={() => {
                                addItemCart(true)
                            }}
                            disabled={sertificatValue <= 100}
                        >
                            {buttonCart ? 'Добавлено в корзину' : <><IconCart /> В корзину</>}
                        </button>
                ) 
            : 
                <button 
                    className={buttonCart ? 'adding-cart' : null} 
                    disabled={productPrice <= 0 || Number(quantity) <= 0} 
                >
                    Нет в наличии
                </button>
            }
        </div>
    )
}
